import { render, staticRenderFns } from "./tabIndex.vue?vue&type=template&id=40027c34"
import script from "./tabIndex.vue?vue&type=script&lang=js"
export * from "./tabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports